import { CordovaPlugins, getZencamLocalizedStrings } from '../../../../shared/CordovaPlugins';
import { isWindows } from '../../../../shared/utils/is';
import { showPermissionDeniedMessage } from '../../../../shared/utils/notifications';
import { ImageAndVideoFieldViewBase } from '../baseMediaFields/views';

export const VideoFieldView = ImageAndVideoFieldViewBase.extend({
    collect_media_camera: function () {
        var this_ = this;

        if (isWindows()) {
            CordovaPlugins().zencam.getZencam(
                function (files) {
                    this_.on_collect_media_success(this_._to_file_collection([files[0].localURL]));
                },
                function (error) {
                    this_.on_collect_media_error(error, 'camera');
                },
                {
                    videoMode: true,
                    strings: getZencamLocalizedStrings()
                }
            );
            return;
        }

        this.required_permissions = 'camera';
        this.is_gallery_permission_granted(function (granted) {
            if (!granted) {
                showPermissionDeniedMessage(
                    _t('mobile_message_media_perimission_denied') + _t('mobile_message_media_perimission_denied_device')
                );
                return;
            }

            CordovaPlugins().media_capture.captureVideo(
                function (files) {
                    this_.on_collect_media_success(this_._to_file_collection([files[0].fullPath]));
                },
                function (error) {
                    this_.on_collect_media_error(error, 'camera');
                },
                { limit: 1 }
            );
        });
        return;
    },

    collect_media_web: function () {
        var this_ = this;

        $f.mobile.uploads.web_filestore.pick_new_file(
            {
                allowed_file_types: 'video/*',
                allow_multiple: false,
                is_media: true
            },
            function (new_files) {
                this_.on_collect_media_success(new_files);
            }
        );

        return false;
    },

    collect_media_gallery: function () {
        var this_ = this;

        CordovaPlugins().camera.getPicture(
            function (file) {
                if (!file) {
                    return;
                }

                this_.on_collect_media_success(this_._to_file_collection([file]));
            },
            function (error) {
                this_.on_collect_media_error(error, 'library');
            },
            {
                saveToPhotoAlbum: false,
                correctOrientation: true,
                popoverOptions: new CordovaPlugins().CameraPopoverOptions(
                    300,
                    300,
                    100,
                    100,
                    CordovaPlugins().camera.PopoverArrowDirection.ARROW_ANY
                ),
                destinationType: CordovaPlugins().camera.DestinationType.NATIVE_URI,
                sourceType: CordovaPlugins().camera.PictureSourceType.PHOTOLIBRARY, // PHOTOLIBRARY, SAVEDPHOTOALBUM, CAMERA
                mediaType: CordovaPlugins().camera.MediaType.VIDEO // only works when sourceType = PHOTOLIBRARY
            }
        );
    }
});
